<template>
	<section class="section">
		<div class="container is-fullhd">
			<template v-for="season in seasons">
				<h1 class="title has-text-centered" v-if="seasons.length > 1">{{ season.season }}</h1>

				<div class="columns is-centered" v-for="league in season.leagues">
					<div class="column is-half">
						<router-link tag="div" class="box league" :to="{ name: 'league-home', params: { leagueKey: league.key } }">
							<div class="title is-4">{{ league.name }}</div>
							<div class="subtitle">{{ league.description }}</div>
						</router-link>
					</div>
				</div>
			</template>
		</div>
	</section>
</template>

<script>
export default {
	computed: {
		seasons() {
			return this.$store.getters.seasons || []
		},
	},
	mounted() {
		this.$store.dispatch("setActiveLeague", null)
		this.$store.dispatch("setActivePage", null)
	},
}
</script>

<style scoped>
.columns + .title {
	margin-top: 5rem;
}

.league {
	cursor: pointer;
}
</style>
